
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic01Off as ObiLogic01OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-01-off.js';
 
 
 

 
 export const ObiLogic01Off = createComponent({
   react: React,
   tagName: 'obi-logic-01-off',
   elementClass: ObiLogic01OffElement,
   events: {
     
   }
  });
 
 